/**
 * OA 免密会话 Cookie 约定（与 open-soa 一致）。
 * Cookie `wiep_oa_session` 为 URLEncode(AES(JSON))；前端不解密。
 * 提交意向单时由 international_api 从 Cookie 解密取 requestId。
 */

/** 与 open-soa LoginConstant.WIEP_OA_SESSION 一致 */
export const WIEP_OA_SESSION_COOKIE = 'wiep_oa_session';

/** 历史 reason 参数，保留 403 文案兼容 */
export const MISSING_REQUEST_ID_REASON = 'missingRequestId';
